import { useGTM } from "../../../hooks";

export type SubscriptionUseCase =
  | "intro_pack"
  | "carrousel_sinistres"
  | "tableau_franchises"
  | "oneprice_nomalus"
  | "etapes_fonctionnement";

export type RecallUseCase = Exclude<SubscriptionUseCase, "intro_pack">;

export type OfferboardChip = "tousrisque" | "autiers";

export type TrustpilotSection = "widget_un" | "widget_deux";

export const useZeroFranchiseTracking = () => {
  const { sendEvent, environnement } = useGTM();

  const trackPageView = () =>
    sendEvent("page_view", {
      environnement,
      page_category: "landing_zero_franchise",
    });

  const trackOnlineSubscription = (useCase: SubscriptionUseCase) =>
    sendEvent("zero_franchise_onlinesubscription", { use_case: useCase });

  const trackRecall = (useCase: RecallUseCase) =>
    sendEvent("zero_franchise_recall", { use_case: useCase });

  const trackOfferboard = (chips: OfferboardChip) =>
    sendEvent("zero_franchise_offerboard", { chips });

  const trackTrustpilot = (section: TrustpilotSection) =>
    sendEvent("zero_franchise_trustpilot", { section });

  return {
    trackPageView,
    trackOnlineSubscription,
    trackRecall,
    trackOfferboard,
    trackTrustpilot,
  };
};
